export default "__VITE_ASSET__75548322__"